export default {
    // apiUrl: "https://localhost:44314/api"
    apiUrl: "https://b2b-api.finekra.com/api",
    //apiUrl: "https://test-b2b-api.finekra.com/api"
}
